/* eslint-disable */
/// <reference path="./custom.d.ts" />
/**
 * Playreport
 * Web API Documentation for Playreport
 *
 * OpenAPI spec version: 3.0.0
 *
 * NOTE: This class is auto generated by the Swaggable code generator program.
 * http://ndo-gitlab.boy.nintendo.co.jp/kawahara_taisuke/rails-swaggable/
 * Do not edit the class manually.
 *
 * Template of this code is based on swagger-codegen typescript-fetch's template.
 * https://github.com/swagger-api/swagger-codegen/tree/master/modules/swagger-codegen/src/main/resources/typescript-fetch
 * Apache License 2.0
 */

import * as url from "url";

import * as changeObject from "change-object-case";
changeObject.options.recursive = true;
changeObject.options.arrayRecursive = true;

function transformKeysToCamelCase(object: any) {
  if (object instanceof Array) {
    return object.map(o => changeObject.camelKeys(o));
  } else {
    return changeObject.camelKeys(object);
  }
}

export interface FetchAPI { (url: string, init?: any): Promise<Response>; }

const BASE_PATH = "/api/v1".replace(/\/+$/, "");
// @ts-ignore
const COLLECTION_FORMATS = {
  'csv': ',',
  'tsv': '   ',
  'ssv': ' ',
  'pipes': '|'
}

export type ApiKey = string | ((name: string) => string);

export interface FetchArgs {
  url: string;
  options: any;
}

export class UnexpectedResponseError extends Error {
  public name = "UnexpectedResponseError"
  constructor(public response: Response, msg?: string) {
    super(msg);
  }
}

export interface ApiResponse {
  code: number | null;
  ok: boolean;
  body: any;
}

function getRailsCsrfToken(): string | null {
  if (document == null) {
    return null;
  }
  const meta = document.querySelector('meta[name=csrf-token]');
  return meta ? meta.getAttribute('content') : null;
}

/**
 * エラーオブジェクト
 */
export interface ApiError {
  /**
   * エラーの概要。対人可読形式の短い文章であること
   */
  title: string;
  /**
   * 対人可読形式のエラーの説明
   */
  detail?: string;
  /**
   * エラーの発生要因を示すオブジェクト
   */
  source?: {
    /**
     * エラーの発生箇所を示すエンティティ(バリデーションエラーであれば属性名を指す)
     */
    pointer: string;
    /**
     * エラーを発生させた具体的な値
     */
    parameter?: string;
  };
  /**
   * HTTPステータスコードの文字列表現
   */
  status?: string;
  /**
   * アプリ固有のエラーコードの文字列表現
   */
  code?: string;
  /**
   * このエラーに関する非定型的な情報を含むオブジェクト
   */
  meta?: { [key: string]: any };
}

export interface BigqueryDryrunResult {
  cost: number;
  dataScannedInBytes: number;
}

export interface BigqueryLoadBatch {
  id: number;
  state: string;
  firstLoad: boolean;
  timeKeyFrom?: string;
  timeKeyTo: string;
  lastError?: string;
  taskCounts: { [key: string]: any };
  createdAt: string;
  updatedAt: string;
  tasks: Array<BigqueryLoadTask>;
}

export interface BigqueryLoadStatus {
  deployed: boolean;
  enabled: boolean;
  running: boolean;
  currentJobId: string;
  currentTimeKey: {
    time: string;
  };
  currentStartedAt: string;
  lastJobId: string;
  lastResult: string;
  lastTimeKey: {
    time: string;
  };
  lastStartedAt: string;
  lastFinishedAt: string;
  lastError: string;
  currentBatch?: BigqueryLoadBatch;
}

export interface BigqueryLoadTask {
  id: number;
  prefix: string;
  granularity: string;
  strategy: string;
  state: string;
  attempts: number;
  bigqueryJobId?: string;
  lastError?: string;
  createdAt: string;
  updatedAt: string;
}

export interface BigqueryQuery {
  query: string;
  queryId: string;
  status: string;
  enqueuedAt: string;
  executionTime: number;
  message?: string;
  cost: number;
}

export interface BigqueryQueryResult {
  query: string;
  queryId: string;
  status: string;
  enqueuedAt: string;
  executionTime: number;
  message?: string;
  cost: number;
  csv: string;
}

export interface BigquerySavedQuery {
  id: number;
  env: string;
  name: string;
  query: string;
}

export interface BigquerySharedQuery {
  id: number;
  env: string;
  name: string;
  query: string;
  userName: string;
  updatable: string;
  deletable: string;
}

/**
 * BigqueryTable モデル
 */
export interface BigqueryTable {
  /**
   * Name
   */
  name: string;
  /**
   * Rows
   */
  rows?: number;
  /**
   * Used size
   */
  usedSize: number;
  /**
   * Event master
   */
  eventMasterId: number;
}

export interface BigqueryTableStatus {
  rowCount: number;
  columns: Array<string>;
  rows: string;
}

export interface ChatHistoriesTitlesBigqueryQueryResponse200 {
  sessionKey: string;
  lastUseTime: number;
}

export interface ChatHistoryTitlesBigqueryQueryResponse200 {
  role: string;
  text: string;
  turnKey: string;
  thoughtsText: string;
  functionCalls: Array<{
    callKey: string;
    name: string;
    args: { [key: string]: any };
  }>;
  toolKind: string;
  callKey: string;
}

export interface ChatTitlesBigqueryQueryPayload {
  prompt: string;
  sessionKey: string;
  turnKey: string;
  retryTurnKey: string;
  functionResponses: Array<{
    callKey: string;
    name: string;
    response: { [key: string]: any };
  }>;
}

export interface CompleteTitlesBigqueryQueryPayload {
  query: string;
}

export interface CompleteTitlesBigqueryQueryResponse200 {
  completion: string;
}

export interface CopyFromS3EventMastersBigqueryPayload {
  versionNumber?: number;
  timeZone?: string;
  timeFrom?: string;
  timeTo?: string;
}

export interface CopyFromS3EventMastersBigqueryResponse200 {
  message: string;
}

export interface CreateTitlesBigqueryQueryPayload {
  query: string;
}

export interface CreateTitlesBigqueryQueryResponse200 {
  queryId: string;
  message: string;
}

export interface CreateTitlesBigqueryQueryResponse400 {
  message: string;
  index: number;
  line: number;
  column: number;
  columnRange: Array<number>;
}

export interface CreateTitlesBigquerySavedQueryPayload {
  name: string;
  query: string;
}

export interface CreateTitlesBigquerySharedQueryPayload {
  name: string;
  query: string;
}

/**
 * createUserTitleRoleのパラメータ
 */
export interface CreateUserTitleRolePayload {
  /**
   * User
   */
  user: {
    /**
     * Role
     */
    role: string;
    /**
     * Ndids
     */
    ndids: string;
    /**
     * Uids
     */
    uids: Array<string>;
  };
}

/**
 * CreateUserTitleRoleResponse200
 */
export interface CreateUserTitleRoleResponse200 {
  /**
   * Message
   */
  message: string;
}

/**
 * CreateUserTitleRoleResponse500
 */
export interface CreateUserTitleRoleResponse500 {
  /**
   * Message
   */
  message: string;
}

export interface DdlEventMastersBigqueryResponse200 {
  current: string;
  next: string;
  migration: string;
}

export interface DeleteEventMastersS3Payload {
  timeZone: string;
  timeFrom: string;
  timeTo: string;
}

export interface DeleteEventMastersS3Response200 {
  message: string;
}

export interface DeployEventMasterEventMastersBigqueryPayload {
  versionNumber?: number;
}

export interface DeployEventMasterEventMastersBigqueryResponse200 {
  message: string;
}

export interface DeployEventMasterEventMastersBigqueryResponse412 {
  message: string;
}

export interface DestroyTitlesBigquerySavedQueryResponse200 {
  message: string;
}

export interface DestroyTitlesBigquerySharedQueryResponse200 {
  message: string;
}

export interface DestroyTitlesBigqueryTableResponse200 {
  message: string;
}

export interface DestroyTitlesBigqueryTableResponse412 {
  message: string;
}

/**
 * DestroyUserTitleRoleResponse200
 */
export interface DestroyUserTitleRoleResponse200 {
  /**
   * Message
   */
  message: string;
}

/**
 * DestroyUserTitleRoleResponse500
 */
export interface DestroyUserTitleRoleResponse500 {
  /**
   * Message
   */
  message: string;
}

export interface DryrunTitlesBigqueryQueryPayload {
  query: string;
}

export interface DryrunTitlesBigqueryQueryResponse400 {
  message: string;
  index: number;
  line: number;
  column: number;
  columnRange: Array<number>;
}

export interface EditTitlesBigqueryQueryPayload {
  query: string;
  prompt: string;
}

export interface EditTitlesBigqueryQueryResponse200 {
  query: string;
}

/**
 * EventMaster モデル
 */
export interface EventMaster {
  /**
   * Definition
   */
  definition: Array<{
    /**
     * Key
     */
    key: string;
    /**
     * Note
     */
    note?: string;
    /**
     * Type
     */
    type: string;
    repeated: boolean;
  }>;
  invalidKeyAllowed: boolean;
  /**
   * PartitionKey
   */
  partitionKey: string;
  clusteringFields: string;
}

export interface ExportTitlesBigqueryQueryResponse200 {
  message: string;
}

export interface FixTitlesBigqueryQueryPayload {
  query: string;
  diagnostics: Array<{
    message: string;
    lineNumber: number;
    column: number;
  }>;
}

export interface FixTitlesBigqueryQueryResponse200 {
  edits: Array<{
    original: string;
    replacement: string;
    lineNumber: number;
  }>;
}

/**
 * IndexTitlesRawPostResponse200
 */
export interface IndexTitlesRawPostResponse200 {
  /**
   * Raw posts
   */
  rawPosts: Array<RawPost>;
  /**
   * Meta
   */
  meta: {
    /**
     * Total Pages
     */
    totalPages: number;
    /**
     * Total Count
     */
    totalCount: number;
    /**
     * Current Page
     */
    currentPage: number;
  };
}

export interface JsonpathEventMastersBigqueryResponse200 {
  path: string;
  json: string;
}

/**
 * LastCopyStatusEventMastersJobResponse200
 */
export interface LastCopyStatusEventMastersJobResponse200 {
  /**
   * Status
   */
  status: string;
  /**
   * Job
   */
  jobId: number;
}

/**
 * LastDeployStatusEventMastersJobResponse200
 */
export interface LastDeployStatusEventMastersJobResponse200 {
  /**
   * Status
   */
  status: string;
}

export interface NesTitlesBigqueryQueryPayload {
  query: string;
  oldText: string;
  newText: string;
}

export interface NesTitlesBigqueryQueryResponse200 {
  edits: Array<{
    original: string;
    replacement: string;
    lineNumber: number;
  }>;
}

/**
 * NotExistUserTitleRole モデル
 */
export interface NotExistUserTitleRole {
  /**
   * NotExistUserTitleRoleのID
   */
  id: number;
  /**
   * Loginid
   */
  loginid: string;
  /**
   * Name
   */
  name: string;
  /**
   * Uid
   */
  uid: string;
  /**
   * Title role
   */
  titleRole: string;
  /**
   * NCLのユーザーかどうか
   */
  isNcl: boolean;
}

/**
 * RawPost モデル
 */
export interface RawPost {
  /**
   * RawPostのID
   */
  id: number;
  /**
   * Application
   */
  applicationId: number;
  /**
   * Event
   */
  eventId: number;
  /**
   * Env
   */
  env: string;
  /**
   * Nsa
   */
  nsaId: string;
  /**
   * Device
   */
  deviceId: string;
  /**
   * Device
   */
  deviceId2: string;
  /**
   * Operation mode
   */
  operationMode: number;
  /**
   * Product model
   */
  productModel: number;
  /**
   * Os version
   */
  osVersion: string;
  /**
   * Rebootless system update version
   */
  rebootlessSystemUpdateVersion: string;
  /**
   * Serial number
   */
  serialNumber: string;
  /**
   * Information for developers
   */
  isChina: boolean;
  /**
   * Information for developers
   */
  isJapan: boolean;
  /**
   * Json
   */
  json: string;
  /**
   * Lc recorded at
   */
  lcRecordedAt: string;
  /**
   * Nc recorded at
   */
  ncRecordedAt: string;
  /**
   * Posted at
   */
  postedAt: string;
  /**
   * Application Version
   */
  applicationVersion: number;
  /**
   * Json errors
   */
  jsonErrors: string;
  /**
   * Json warnings
   */
  jsonWarnings: string;
  /**
   * Event master
   */
  eventMasterId: number;
  /**
   * Event master definition
   */
  eventMasterDefinition: string;
}

/**
 * S3Object モデル
 */
export interface S3Object {
  /**
   * Path
   */
  path: string;
  /**
   * Datasize
   */
  dataSize: string;
  /**
   * Date
   */
  date: string;
  /**
   * Last modified
   */
  lastModified: string;
  /**
   * Etag
   */
  etag: string;
}

/**
 * S3Stats モデル
 */
export interface S3Stats {
  /**
   * Term
   */
  term: string;
  /**
   * Datetime
   */
  datetime: string;
  /**
   * File count
   */
  fileCount: number;
  /**
   * Total size
   */
  totalSize: number;
}

export interface ShowTitlesBigqueryChatPreferenceResponse200 {
  userInstruction: string;
  titleUserInstruction: string;
}

export interface StopTitlesBigqueryQueryResponse200 {
  message: string;
}

/**
 * updateEventMasterのパラメータ
 */
export interface UpdateEventMasterPayload {
  /**
   * Event master
   */
  eventMaster: {
    /**
     * Definition
     */
    definition?: string;
    partitionKey?: string;
    clusteringFields?: string;
    versionNote?: string;
  };
}

/**
 * UpdateEventMasterResponse200
 */
export interface UpdateEventMasterResponse200 {
  /**
   * Message
   */
  message: string;
  /**
   * Version number
   */
  versionNumber: number;
}

export interface UpdateTitlesBigqueryChatPreferencePayload {
  userInstruction: string;
  titleUserInstruction: string;
}

export interface UpdateTitlesBigqueryChatPreferenceResponse200 {
  userInstruction: string;
  titleUserInstruction: string;
}

export interface UpdateTitlesBigquerySavedQueryPayload {
  name: string;
  query: string;
}

export interface UpdateTitlesBigquerySharedQueryPayload {
  name: string;
  query: string;
}

/**
 * updateUserTitleRoleのパラメータ
 */
export interface UpdateUserTitleRolePayload {
  /**
   * User
   */
  user: {
    /**
     * Role
     */
    role: string;
    /**
     * Ids
     */
    ids: Array<number>;
  };
}

/**
 * UpdateUserTitleRoleResponse200
 */
export interface UpdateUserTitleRoleResponse200 {
  /**
   * Message
   */
  message: string;
}

/**
 * UpdateUserTitleRoleResponse500
 */
export interface UpdateUserTitleRoleResponse500 {
  /**
   * Message
   */
  message: string;
}

export interface UpdateVersionNoteEventMasterPayload {
  note?: string;
}

export interface UpdateVersionNoteEventMasterResponse200 {
  message: string;
}

/**
 * UserTitleRole モデル
 */
export interface UserTitleRole {
  /**
   * UserTitleRoleのID
   */
  id: number;
  /**
   * Loginid
   */
  loginid: string;
  /**
   * Name
   */
  name: string;
  /**
   * Uid
   */
  uid: string;
  /**
   * Title role
   */
  titleRole: string;
  /**
   * NCLのユーザーかどうか
   */
  isNcl: boolean;
}
/**
 * BigqueryApi - fetch parameter creator
 */
export const BigqueryApiFetchParamCreator = {
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param tableName 
     * @param {*} [options] Override http request option.
     */
    ddlTitlesBigqueryTable(
      titleUuid: string,
      env: string,
      tableName: string,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/tables/{table_name}`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)))
        .replace(`{${"table_name"}}`, encodeURIComponent(String(tableName)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param tableName 
     * @param {*} [options] Override http request option.
     */
    destroyTitlesBigqueryTable(
      titleUuid: string,
      env: string,
      tableName: string,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'DELETE';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/tables/{table_name}`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)))
        .replace(`{${"table_name"}}`, encodeURIComponent(String(tableName)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    indexTitlesBigqueryTable(
      titleUuid: string,
      env: string,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/tables`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
};
/**
 * EventMastersApi - fetch parameter creator
 */
export const EventMastersApiFetchParamCreator = {
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    copyFromS3EventMastersBigquery(
      eventMasterId: number,
      env: string,
      body: CopyFromS3EventMastersBigqueryPayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'POST';
      const localVarPath = `/event_masters/{event_master_id}/copy_from_s3/{env}`
        .replace(`{${"event_master_id"}}`, encodeURIComponent(String(eventMasterId)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param params.versionNumber 
     * @param {*} [options] Override http request option.
     */
    ddlEventMastersBigquery(
      eventMasterId: number,
      env: string,
      params: {
        versionNumber?: number;      },
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/event_masters/{event_master_id}/ddl/{env}`
        .replace(`{${"event_master_id"}}`, encodeURIComponent(String(eventMasterId)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      if (params != null && params.versionNumber != null) {
        localVarQueryParameter['version_number'] = params.versionNumber
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    deleteEventMastersS3(
      eventMasterId: number,
      env: string,
      body: DeleteEventMastersS3Payload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'POST';
      const localVarPath = `/event_masters/{event_master_id}/s3/{env}/delete`
        .replace(`{${"event_master_id"}}`, encodeURIComponent(String(eventMasterId)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    deployEventMasterEventMastersBigquery(
      eventMasterId: number,
      env: string,
      body: DeployEventMasterEventMastersBigqueryPayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'POST';
      const localVarPath = `/event_masters/{event_master_id}/deploy/{env}`
        .replace(`{${"event_master_id"}}`, encodeURIComponent(String(eventMasterId)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    jsonpathEventMastersBigquery(
      eventMasterId: number,
      env: string,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/event_masters/{event_master_id}/jsonpath/{env}`
        .replace(`{${"event_master_id"}}`, encodeURIComponent(String(eventMasterId)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Last copy status Job
     * @summary Last copy status Job
     * @param eventMasterId Event Master Id
     * @param {*} [options] Override http request option.
     */
    lastCopyStatusEventMastersJob(
      eventMasterId: number,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/event_masters/{event_master_id}/last_copy_status`
        .replace(`{${"event_master_id"}}`, encodeURIComponent(String(eventMasterId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Last deploy status Job
     * @summary Last deploy status Job
     * @param eventMasterId Event Master Id
     * @param {*} [options] Override http request option.
     */
    lastDeployStatusEventMastersJob(
      eventMasterId: number,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/event_masters/{event_master_id}/last_deploy_status`
        .replace(`{${"event_master_id"}}`, encodeURIComponent(String(eventMasterId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param params.versionNumber 
     * @param params.timeZone 
     * @param params.timeFrom 
     * @param params.timeTo 
     * @param {*} [options] Override http request option.
     */
    s3StatsEventMastersBigquery(
      eventMasterId: number,
      env: string,
      params: {
        versionNumber?: number;
        timeZone?: string;
        timeFrom?: string;
        timeTo?: string;      },
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/event_masters/{event_master_id}/s3/{env}`
        .replace(`{${"event_master_id"}}`, encodeURIComponent(String(eventMasterId)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      if (params != null && params.versionNumber != null) {
        localVarQueryParameter['version_number'] = params.versionNumber
      }

      if (params != null && params.timeZone != null) {
        localVarQueryParameter['time_zone'] = params.timeZone
      }

      if (params != null && params.timeFrom != null) {
        localVarQueryParameter['time_from'] = params.timeFrom
      }

      if (params != null && params.timeTo != null) {
        localVarQueryParameter['time_to'] = params.timeTo
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * EventMasterを取得します。
     * @summary EventMasterの取得
     * @param id EventMasterのID
     * @param params.versionNumber Version Number
     * @param {*} [options] Override http request option.
     */
    showEventMaster(
      id: number,
      params: {
        /**
         * Version Number
         */
        versionNumber?: number;      },
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/event_masters/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      if (params != null && params.versionNumber != null) {
        localVarQueryParameter['version_number'] = params.versionNumber
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    showEventMastersBigqueryLoadStatus(
      eventMasterId: number,
      env: string,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/event_masters/{event_master_id}/bigquery_load_statuses/{env}`
        .replace(`{${"event_master_id"}}`, encodeURIComponent(String(eventMasterId)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Suggestionを取得します。
     * @summary Suggestionの取得
     * @param eventMasterId Event Master Id
     * @param params.limit Limit
     * @param params.env Env
     * @param {*} [options] Override http request option.
     */
    showEventMastersSuggestion(
      eventMasterId: number,
      params: {
        /**
         * Limit
         */
        limit: string;
        /**
         * Env
         */
        env: string;      },
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/event_masters/{event_master_id}/suggestion`
        .replace(`{${"event_master_id"}}`, encodeURIComponent(String(eventMasterId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      if (params != null && params.limit != null) {
        localVarQueryParameter['limit'] = params.limit
      }

      if (params != null && params.env != null) {
        localVarQueryParameter['env'] = params.env
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param params.versionNumber 
     * @param {*} [options] Override http request option.
     */
    tableStatusEventMastersBigquery(
      eventMasterId: number,
      env: string,
      params: {
        versionNumber?: number;      },
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/event_masters/{event_master_id}/table_status/{env}`
        .replace(`{${"event_master_id"}}`, encodeURIComponent(String(eventMasterId)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      if (params != null && params.versionNumber != null) {
        localVarQueryParameter['version_number'] = params.versionNumber
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * EventMasterを更新します。
     * @summary EventMasterの更新
     * @param id EventMasterのID
     * @param body 
     * @param {*} [options] Override http request option.
     */
    updateEventMaster(
      id: number,
      body: UpdateEventMasterPayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'PATCH';
      const localVarPath = `/event_masters/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param eventMasterId 
     * @param versionId 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    updateVersionNoteEventMaster(
      eventMasterId: number,
      versionId: number,
      body: UpdateVersionNoteEventMasterPayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'PATCH';
      const localVarPath = `/event_masters/{event_master_id}/versions/{version_id}/note`
        .replace(`{${"event_master_id"}}`, encodeURIComponent(String(eventMasterId)))
        .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
};
/**
 * QueryApi - fetch parameter creator
 */
export const QueryApiFetchParamCreator = {
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    chatHistoriesTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/queries/chat/histories`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param sessionKey 
     * @param {*} [options] Override http request option.
     */
    chatHistoryTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      sessionKey: string,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/queries/chat/histories/{session_key}`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)))
        .replace(`{${"session_key"}}`, encodeURIComponent(String(sessionKey)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    chatTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      body: ChatTitlesBigqueryQueryPayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'POST';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/queries/chat`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    completeTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      body: CompleteTitlesBigqueryQueryPayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'POST';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/queries/complete`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    createTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      body: CreateTitlesBigqueryQueryPayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'POST';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/queries`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    dryrunTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      body: DryrunTitlesBigqueryQueryPayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'POST';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/queries/dryrun`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    editTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      body: EditTitlesBigqueryQueryPayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'POST';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/queries/edit`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param queryId 
     * @param {*} [options] Override http request option.
     */
    exportTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      queryId: string,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'POST';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/queries/{query_id}/export`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)))
        .replace(`{${"query_id"}}`, encodeURIComponent(String(queryId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    fixTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      body: FixTitlesBigqueryQueryPayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'POST';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/queries/fix`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    indexTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/queries`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    nesTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      body: NesTitlesBigqueryQueryPayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'POST';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/queries/nes`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    showTitlesBigqueryChatPreference(
      titleUuid: string,
      env: string,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/queries/chat/preferences`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param queryId 
     * @param {*} [options] Override http request option.
     */
    showTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      queryId: string,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/queries/{query_id}`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)))
        .replace(`{${"query_id"}}`, encodeURIComponent(String(queryId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param queryId 
     * @param {*} [options] Override http request option.
     */
    stopTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      queryId: string,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'PUT';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/queries/{query_id}/stop`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)))
        .replace(`{${"query_id"}}`, encodeURIComponent(String(queryId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    updateTitlesBigqueryChatPreference(
      titleUuid: string,
      env: string,
      body: UpdateTitlesBigqueryChatPreferencePayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'PUT';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/queries/chat/preferences`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
};
/**
 * RawPostsApi - fetch parameter creator
 */
export const RawPostsApiFetchParamCreator = {
    /**
     * RawPostの一覧を取得します。
     * @summary RawPostの一覧
     * @param titleUuid 
     * @param params.q.eventIdCont Q Event Id Cont
     * @param params.q.eventIdEq Q Event Id Eq
     * @param params.q.nsaIdEq Q Nsa Id Eq
     * @param params.q.deviceId2Eq 
     * @param params.q.envIn Q Env In
     * @param params.q.serialNumberEq Q Serial Number Eq
     * @param params.per Per
     * @param params.page Page
     * @param {*} [options] Override http request option.
     */
    indexTitlesRawPost(
      titleUuid: string,
      params: {
        q?: {
          /**
           * Q Event Id Cont
           */
          eventIdCont?: string;
          /**
           * Q Event Id Eq
           */
          eventIdEq?: string;
          /**
           * Q Nsa Id Eq
           */
          nsaIdEq?: string;
          deviceId2Eq?: string;
          /**
           * Q Env In
           */
          envIn?: Array<string>;
          /**
           * Q Serial Number Eq
           */
          serialNumberEq?: string;
        }
        /**
         * Per
         */
        per?: number;
        /**
         * Page
         */
        page?: number;      },
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/titles/{title_uuid}/raw_posts`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      if (params != null && params.q != null && params.q.eventIdCont != null) {
        localVarQueryParameter['q[event_id_cont]'] = params.q.eventIdCont
      }

      if (params != null && params.q != null && params.q.eventIdEq != null) {
        localVarQueryParameter['q[event_id_eq]'] = params.q.eventIdEq
      }

      if (params != null && params.q != null && params.q.nsaIdEq != null) {
        localVarQueryParameter['q[nsa_id_eq]'] = params.q.nsaIdEq
      }

      if (params != null && params.q != null && params.q.deviceId2Eq != null) {
        localVarQueryParameter['q[device_id2_eq]'] = params.q.deviceId2Eq
      }

      if (params != null && params.q != null && params.q.envIn != null) {
        localVarQueryParameter['q[env_in][]'] = params.q.envIn
      }

      if (params != null && params.q != null && params.q.serialNumberEq != null) {
        localVarQueryParameter['q[serial_number_eq]'] = params.q.serialNumberEq
      }

      if (params != null && params.per != null) {
        localVarQueryParameter['per'] = params.per
      }

      if (params != null && params.page != null) {
        localVarQueryParameter['page'] = params.page
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * RawPostを取得します。
     * @summary RawPostの取得
     * @param id RawPostのID
     * @param {*} [options] Override http request option.
     */
    showRawPost(
      id: number,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/raw_posts/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
};
/**
 * SavedQueryApi - fetch parameter creator
 */
export const SavedQueryApiFetchParamCreator = {
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    createTitlesBigquerySavedQuery(
      titleUuid: string,
      env: string,
      body: CreateTitlesBigquerySavedQueryPayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'POST';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/saved_queries`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param savedQueryId 
     * @param {*} [options] Override http request option.
     */
    destroyTitlesBigquerySavedQuery(
      titleUuid: string,
      env: string,
      savedQueryId: number,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'DELETE';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/saved_queries/{saved_query_id}`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)))
        .replace(`{${"saved_query_id"}}`, encodeURIComponent(String(savedQueryId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    indexTitlesBigquerySavedQuery(
      titleUuid: string,
      env: string,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/saved_queries`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param savedQueryId 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    updateTitlesBigquerySavedQuery(
      titleUuid: string,
      env: string,
      savedQueryId: number,
      body: UpdateTitlesBigquerySavedQueryPayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'PUT';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/saved_queries/{saved_query_id}`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)))
        .replace(`{${"saved_query_id"}}`, encodeURIComponent(String(savedQueryId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
};
/**
 * SharedQueryApi - fetch parameter creator
 */
export const SharedQueryApiFetchParamCreator = {
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    createTitlesBigquerySharedQuery(
      titleUuid: string,
      env: string,
      body: CreateTitlesBigquerySharedQueryPayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'POST';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/shared_queries`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param sharedQueryId 
     * @param {*} [options] Override http request option.
     */
    destroyTitlesBigquerySharedQuery(
      titleUuid: string,
      env: string,
      sharedQueryId: number,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'DELETE';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/shared_queries/{shared_query_id}`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)))
        .replace(`{${"shared_query_id"}}`, encodeURIComponent(String(sharedQueryId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    indexTitlesBigquerySharedQuery(
      titleUuid: string,
      env: string,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/shared_queries`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param sharedQueryId 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    updateTitlesBigquerySharedQuery(
      titleUuid: string,
      env: string,
      sharedQueryId: number,
      body: UpdateTitlesBigquerySharedQueryPayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'PUT';
      const localVarPath = `/titles/{title_uuid}/bigquery/{env}/shared_queries/{shared_query_id}`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)))
        .replace(`{${"env"}}`, encodeURIComponent(String(env)))
        .replace(`{${"shared_query_id"}}`, encodeURIComponent(String(sharedQueryId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
};
/**
 * StatusesApi - fetch parameter creator
 */
export const StatusesApiFetchParamCreator = {
    /**
     * Get Status
     * @summary Get Status
     * @param {*} [options] Override http request option.
     */
    getStatus(
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/status`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
};
/**
 * UserTitleRolesApi - fetch parameter creator
 */
export const UserTitleRolesApiFetchParamCreator = {
    /**
     * UserTitleRoleを新規に作成します。
     * @summary UserTitleRoleの作成
     * @param titleUuid 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    createUserTitleRole(
      titleUuid: string,
      body: CreateUserTitleRolePayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'POST';
      const localVarPath = `/users/titles/{title_uuid}/roles`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * UserTitleRoleを削除します。
     * @summary UserTitleRoleの削除
     * @param titleUuid 
     * @param params.user.ids User Ids
     * @param {*} [options] Override http request option.
     */
    destroyUserTitleRole(
      titleUuid: string,
      params: {
        user: {
          /**
           * User Ids
           */
          ids: Array<number>;
        }      },
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'DELETE';
      const localVarPath = `/users/titles/{title_uuid}/roles`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      if (params != null && params.user != null && params.user.ids != null) {
        localVarQueryParameter['user[ids][]'] = params.user.ids
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Registered UserTitleRole
     * @summary Registered UserTitleRole
     * @param titleUuid 
     * @param {*} [options] Override http request option.
     */
    registeredUserTitleRole(
      titleUuid: string,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/users/titles/{title_uuid}/registered`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Unregistered UserTitleRole
     * @summary Unregistered UserTitleRole
     * @param titleUuid 
     * @param params.loginidFilter 
     * @param {*} [options] Override http request option.
     */
    unregisteredUserTitleRole(
      titleUuid: string,
      params: {
        loginidFilter: string;      },
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'GET';
      const localVarPath = `/users/titles/{title_uuid}/unregistered`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      if (params != null && params.loginidFilter != null) {
        localVarQueryParameter['loginid_filter'] = params.loginidFilter
      }

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * UserTitleRoleを更新します。
     * @summary UserTitleRoleの更新
     * @param titleUuid 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    updateUserTitleRole(
      titleUuid: string,
      body: UpdateUserTitleRolePayload,
      options: any = {},
    ): FetchArgs {
      const httpMethod: string = 'PUT';
      const localVarPath = `/users/titles/{title_uuid}/roles`
        .replace(`{${"title_uuid"}}`, encodeURIComponent(String(titleUuid)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: httpMethod, credentials: 'same-origin' }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const railsCsrfToken = getRailsCsrfToken();
      if (httpMethod !== 'GET' && railsCsrfToken != null) {
        localVarHeaderParameter['X-CSRF-Token'] = railsCsrfToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      // @ts-ignore TS2790
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
      localVarRequestOptions.body = JSON.stringify(changeObject.snakeKeys(body) || {});

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
};
// @ts-ignore
export const ClientFactory = (basePath: string = BASE_PATH, apiKey?: ApiKey) => ({
  /**
   * BigqueryApi
   */
  BigqueryApi: {
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param tableName 
     * @param {*} [options] Override http request option.
     */
    async ddlTitlesBigqueryTable(
      titleUuid: string,
      env: string,
      tableName: string,
      options: any = {},
      ): Promise<BigqueryApi.DdlTitlesBigqueryTableResponse> {
      const fetchArgs = BigqueryApiFetchParamCreator.ddlTitlesBigqueryTable(
        titleUuid,
        env,
        tableName,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: await response.text() };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param tableName 
     * @param {*} [options] Override http request option.
     */
    async destroyTitlesBigqueryTable(
      titleUuid: string,
      env: string,
      tableName: string,
      options: any = {},
      ): Promise<BigqueryApi.DestroyTitlesBigqueryTableResponse> {
      const fetchArgs = BigqueryApiFetchParamCreator.destroyTitlesBigqueryTable(
        titleUuid,
        env,
        tableName,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 412:
          return { code: 412, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    async indexTitlesBigqueryTable(
      titleUuid: string,
      env: string,
      options: any = {},
      ): Promise<BigqueryApi.IndexTitlesBigqueryTableResponse> {
      const fetchArgs = BigqueryApiFetchParamCreator.indexTitlesBigqueryTable(
        titleUuid,
        env,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
  },
  /**
   * EventMastersApi
   */
  EventMastersApi: {
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async copyFromS3EventMastersBigquery(
      eventMasterId: number,
      env: string,
      body: {
        versionNumber?: number;
        timeZone?: string;
        timeFrom?: string;
        timeTo?: string;
      },
      options: any = {},
      ): Promise<EventMastersApi.CopyFromS3EventMastersBigqueryResponse> {
      const fetchArgs = EventMastersApiFetchParamCreator.copyFromS3EventMastersBigquery(
        eventMasterId,
        env,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 503:
          return { code: 503, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param params.versionNumber 
     * @param {*} [options] Override http request option.
     */
    async ddlEventMastersBigquery(
      eventMasterId: number,
      env: string,
      params: {
        versionNumber?: number;      },
      options: any = {},
      ): Promise<EventMastersApi.DdlEventMastersBigqueryResponse> {
      const fetchArgs = EventMastersApiFetchParamCreator.ddlEventMastersBigquery(
        eventMasterId,
        env,
        params,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 503:
          return { code: 503, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async deleteEventMastersS3(
      eventMasterId: number,
      env: string,
      body: {
        timeZone: string;
        timeFrom: string;
        timeTo: string;
      },
      options: any = {},
      ): Promise<EventMastersApi.DeleteEventMastersS3Response> {
      const fetchArgs = EventMastersApiFetchParamCreator.deleteEventMastersS3(
        eventMasterId,
        env,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async deployEventMasterEventMastersBigquery(
      eventMasterId: number,
      env: string,
      body: {
        versionNumber?: number;
      },
      options: any = {},
      ): Promise<EventMastersApi.DeployEventMasterEventMastersBigqueryResponse> {
      const fetchArgs = EventMastersApiFetchParamCreator.deployEventMasterEventMastersBigquery(
        eventMasterId,
        env,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 412:
          return { code: 412, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 503:
          return { code: 503, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    async jsonpathEventMastersBigquery(
      eventMasterId: number,
      env: string,
      options: any = {},
      ): Promise<EventMastersApi.JsonpathEventMastersBigqueryResponse> {
      const fetchArgs = EventMastersApiFetchParamCreator.jsonpathEventMastersBigquery(
        eventMasterId,
        env,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 503:
          return { code: 503, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * Last copy status Job
     * @summary Last copy status Job
     * @param eventMasterId Event Master Id
     * @param {*} [options] Override http request option.
     */
    async lastCopyStatusEventMastersJob(
      eventMasterId: number,
      options: any = {},
      ): Promise<EventMastersApi.LastCopyStatusEventMastersJobResponse> {
      const fetchArgs = EventMastersApiFetchParamCreator.lastCopyStatusEventMastersJob(
        eventMasterId,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * Last deploy status Job
     * @summary Last deploy status Job
     * @param eventMasterId Event Master Id
     * @param {*} [options] Override http request option.
     */
    async lastDeployStatusEventMastersJob(
      eventMasterId: number,
      options: any = {},
      ): Promise<EventMastersApi.LastDeployStatusEventMastersJobResponse> {
      const fetchArgs = EventMastersApiFetchParamCreator.lastDeployStatusEventMastersJob(
        eventMasterId,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param params.versionNumber 
     * @param params.timeZone 
     * @param params.timeFrom 
     * @param params.timeTo 
     * @param {*} [options] Override http request option.
     */
    async s3StatsEventMastersBigquery(
      eventMasterId: number,
      env: string,
      params: {
        versionNumber?: number;
        timeZone?: string;
        timeFrom?: string;
        timeTo?: string;      },
      options: any = {},
      ): Promise<EventMastersApi.S3StatsEventMastersBigqueryResponse> {
      const fetchArgs = EventMastersApiFetchParamCreator.s3StatsEventMastersBigquery(
        eventMasterId,
        env,
        params,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 503:
          return { code: 503, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * EventMasterを取得します。
     * @summary EventMasterの取得
     * @param id EventMasterのID
     * @param params.versionNumber Version Number
     * @param {*} [options] Override http request option.
     */
    async showEventMaster(
      id: number,
      params: {
        /**
         * Version Number
         */
        versionNumber?: number;      },
      options: any = {},
      ): Promise<EventMastersApi.ShowEventMasterResponse> {
      const fetchArgs = EventMastersApiFetchParamCreator.showEventMaster(
        id,
        params,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    async showEventMastersBigqueryLoadStatus(
      eventMasterId: number,
      env: string,
      options: any = {},
      ): Promise<EventMastersApi.ShowEventMastersBigqueryLoadStatusResponse> {
      const fetchArgs = EventMastersApiFetchParamCreator.showEventMastersBigqueryLoadStatus(
        eventMasterId,
        env,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * Suggestionを取得します。
     * @summary Suggestionの取得
     * @param eventMasterId Event Master Id
     * @param params.limit Limit
     * @param params.env Env
     * @param {*} [options] Override http request option.
     */
    async showEventMastersSuggestion(
      eventMasterId: number,
      params: {
        /**
         * Limit
         */
        limit: string;
        /**
         * Env
         */
        env: string;      },
      options: any = {},
      ): Promise<EventMastersApi.ShowEventMastersSuggestionResponse> {
      const fetchArgs = EventMastersApiFetchParamCreator.showEventMastersSuggestion(
        eventMasterId,
        params,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: await response.text() };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param eventMasterId 
     * @param env 
     * @param params.versionNumber 
     * @param {*} [options] Override http request option.
     */
    async tableStatusEventMastersBigquery(
      eventMasterId: number,
      env: string,
      params: {
        versionNumber?: number;      },
      options: any = {},
      ): Promise<EventMastersApi.TableStatusEventMastersBigqueryResponse> {
      const fetchArgs = EventMastersApiFetchParamCreator.tableStatusEventMastersBigquery(
        eventMasterId,
        env,
        params,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 503:
          return { code: 503, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * EventMasterを更新します。
     * @summary EventMasterの更新
     * @param id EventMasterのID
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async updateEventMaster(
      id: number,
      body: {
        /**
         * Event master
         */
        eventMaster: {
          /**
           * Definition
           */
          definition?: string;
          partitionKey?: string;
          clusteringFields?: string;
          versionNote?: string;
        };
      },
      options: any = {},
      ): Promise<EventMastersApi.UpdateEventMasterResponse> {
      const fetchArgs = EventMastersApiFetchParamCreator.updateEventMaster(
        id,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param eventMasterId 
     * @param versionId 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async updateVersionNoteEventMaster(
      eventMasterId: number,
      versionId: number,
      body: {
        note?: string;
      },
      options: any = {},
      ): Promise<EventMastersApi.UpdateVersionNoteEventMasterResponse> {
      const fetchArgs = EventMastersApiFetchParamCreator.updateVersionNoteEventMaster(
        eventMasterId,
        versionId,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
  },
  /**
   * QueryApi
   */
  QueryApi: {
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    async chatHistoriesTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      options: any = {},
      ): Promise<QueryApi.ChatHistoriesTitlesBigqueryQueryResponse> {
      const fetchArgs = QueryApiFetchParamCreator.chatHistoriesTitlesBigqueryQuery(
        titleUuid,
        env,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param sessionKey 
     * @param {*} [options] Override http request option.
     */
    async chatHistoryTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      sessionKey: string,
      options: any = {},
      ): Promise<QueryApi.ChatHistoryTitlesBigqueryQueryResponse> {
      const fetchArgs = QueryApiFetchParamCreator.chatHistoryTitlesBigqueryQuery(
        titleUuid,
        env,
        sessionKey,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async chatTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      body: {
        prompt: string;
        sessionKey: string;
        turnKey: string;
        retryTurnKey: string;
        functionResponses: Array<{
          callKey: string;
          name: string;
          response: { [key: string]: any };
        }>;
      },
      options: any = {},
      ): Promise<QueryApi.ChatTitlesBigqueryQueryResponse> {
      const fetchArgs = QueryApiFetchParamCreator.chatTitlesBigqueryQuery(
        titleUuid,
        env,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async completeTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      body: {
        query: string;
      },
      options: any = {},
      ): Promise<QueryApi.CompleteTitlesBigqueryQueryResponse> {
      const fetchArgs = QueryApiFetchParamCreator.completeTitlesBigqueryQuery(
        titleUuid,
        env,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async createTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      body: {
        query: string;
      },
      options: any = {},
      ): Promise<QueryApi.CreateTitlesBigqueryQueryResponse> {
      const fetchArgs = QueryApiFetchParamCreator.createTitlesBigqueryQuery(
        titleUuid,
        env,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 400:
          return { code: 400, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async dryrunTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      body: {
        query: string;
      },
      options: any = {},
      ): Promise<QueryApi.DryrunTitlesBigqueryQueryResponse> {
      const fetchArgs = QueryApiFetchParamCreator.dryrunTitlesBigqueryQuery(
        titleUuid,
        env,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 400:
          return { code: 400, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async editTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      body: {
        query: string;
        prompt: string;
      },
      options: any = {},
      ): Promise<QueryApi.EditTitlesBigqueryQueryResponse> {
      const fetchArgs = QueryApiFetchParamCreator.editTitlesBigqueryQuery(
        titleUuid,
        env,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param queryId 
     * @param {*} [options] Override http request option.
     */
    async exportTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      queryId: string,
      options: any = {},
      ): Promise<QueryApi.ExportTitlesBigqueryQueryResponse> {
      const fetchArgs = QueryApiFetchParamCreator.exportTitlesBigqueryQuery(
        titleUuid,
        env,
        queryId,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async fixTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      body: {
        query: string;
        diagnostics: Array<{
          message: string;
          lineNumber: number;
          column: number;
        }>;
      },
      options: any = {},
      ): Promise<QueryApi.FixTitlesBigqueryQueryResponse> {
      const fetchArgs = QueryApiFetchParamCreator.fixTitlesBigqueryQuery(
        titleUuid,
        env,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    async indexTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      options: any = {},
      ): Promise<QueryApi.IndexTitlesBigqueryQueryResponse> {
      const fetchArgs = QueryApiFetchParamCreator.indexTitlesBigqueryQuery(
        titleUuid,
        env,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async nesTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      body: {
        query: string;
        oldText: string;
        newText: string;
      },
      options: any = {},
      ): Promise<QueryApi.NesTitlesBigqueryQueryResponse> {
      const fetchArgs = QueryApiFetchParamCreator.nesTitlesBigqueryQuery(
        titleUuid,
        env,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    async showTitlesBigqueryChatPreference(
      titleUuid: string,
      env: string,
      options: any = {},
      ): Promise<QueryApi.ShowTitlesBigqueryChatPreferenceResponse> {
      const fetchArgs = QueryApiFetchParamCreator.showTitlesBigqueryChatPreference(
        titleUuid,
        env,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param queryId 
     * @param {*} [options] Override http request option.
     */
    async showTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      queryId: string,
      options: any = {},
      ): Promise<QueryApi.ShowTitlesBigqueryQueryResponse> {
      const fetchArgs = QueryApiFetchParamCreator.showTitlesBigqueryQuery(
        titleUuid,
        env,
        queryId,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param queryId 
     * @param {*} [options] Override http request option.
     */
    async stopTitlesBigqueryQuery(
      titleUuid: string,
      env: string,
      queryId: string,
      options: any = {},
      ): Promise<QueryApi.StopTitlesBigqueryQueryResponse> {
      const fetchArgs = QueryApiFetchParamCreator.stopTitlesBigqueryQuery(
        titleUuid,
        env,
        queryId,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async updateTitlesBigqueryChatPreference(
      titleUuid: string,
      env: string,
      body: {
        userInstruction: string;
        titleUserInstruction: string;
      },
      options: any = {},
      ): Promise<QueryApi.UpdateTitlesBigqueryChatPreferenceResponse> {
      const fetchArgs = QueryApiFetchParamCreator.updateTitlesBigqueryChatPreference(
        titleUuid,
        env,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
  },
  /**
   * RawPostsApi
   */
  RawPostsApi: {
    /**
     * RawPostの一覧を取得します。
     * @summary RawPostの一覧
     * @param titleUuid 
     * @param params.q.eventIdCont Q Event Id Cont
     * @param params.q.eventIdEq Q Event Id Eq
     * @param params.q.nsaIdEq Q Nsa Id Eq
     * @param params.q.deviceId2Eq 
     * @param params.q.envIn Q Env In
     * @param params.q.serialNumberEq Q Serial Number Eq
     * @param params.per Per
     * @param params.page Page
     * @param {*} [options] Override http request option.
     */
    async indexTitlesRawPost(
      titleUuid: string,
      params: {
        q?: {
          /**
           * Q Event Id Cont
           */
          eventIdCont?: string;
          /**
           * Q Event Id Eq
           */
          eventIdEq?: string;
          /**
           * Q Nsa Id Eq
           */
          nsaIdEq?: string;
          deviceId2Eq?: string;
          /**
           * Q Env In
           */
          envIn?: Array<string>;
          /**
           * Q Serial Number Eq
           */
          serialNumberEq?: string;
        }
        /**
         * Per
         */
        per?: number;
        /**
         * Page
         */
        page?: number;      },
      options: any = {},
      ): Promise<RawPostsApi.IndexTitlesRawPostResponse> {
      const fetchArgs = RawPostsApiFetchParamCreator.indexTitlesRawPost(
        titleUuid,
        params,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * RawPostを取得します。
     * @summary RawPostの取得
     * @param id RawPostのID
     * @param {*} [options] Override http request option.
     */
    async showRawPost(
      id: number,
      options: any = {},
      ): Promise<RawPostsApi.ShowRawPostResponse> {
      const fetchArgs = RawPostsApiFetchParamCreator.showRawPost(
        id,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
  },
  /**
   * SavedQueryApi
   */
  SavedQueryApi: {
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async createTitlesBigquerySavedQuery(
      titleUuid: string,
      env: string,
      body: {
        name: string;
        query: string;
      },
      options: any = {},
      ): Promise<SavedQueryApi.CreateTitlesBigquerySavedQueryResponse> {
      const fetchArgs = SavedQueryApiFetchParamCreator.createTitlesBigquerySavedQuery(
        titleUuid,
        env,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param savedQueryId 
     * @param {*} [options] Override http request option.
     */
    async destroyTitlesBigquerySavedQuery(
      titleUuid: string,
      env: string,
      savedQueryId: number,
      options: any = {},
      ): Promise<SavedQueryApi.DestroyTitlesBigquerySavedQueryResponse> {
      const fetchArgs = SavedQueryApiFetchParamCreator.destroyTitlesBigquerySavedQuery(
        titleUuid,
        env,
        savedQueryId,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    async indexTitlesBigquerySavedQuery(
      titleUuid: string,
      env: string,
      options: any = {},
      ): Promise<SavedQueryApi.IndexTitlesBigquerySavedQueryResponse> {
      const fetchArgs = SavedQueryApiFetchParamCreator.indexTitlesBigquerySavedQuery(
        titleUuid,
        env,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param savedQueryId 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async updateTitlesBigquerySavedQuery(
      titleUuid: string,
      env: string,
      savedQueryId: number,
      body: {
        name: string;
        query: string;
      },
      options: any = {},
      ): Promise<SavedQueryApi.UpdateTitlesBigquerySavedQueryResponse> {
      const fetchArgs = SavedQueryApiFetchParamCreator.updateTitlesBigquerySavedQuery(
        titleUuid,
        env,
        savedQueryId,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
  },
  /**
   * SharedQueryApi
   */
  SharedQueryApi: {
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async createTitlesBigquerySharedQuery(
      titleUuid: string,
      env: string,
      body: {
        name: string;
        query: string;
      },
      options: any = {},
      ): Promise<SharedQueryApi.CreateTitlesBigquerySharedQueryResponse> {
      const fetchArgs = SharedQueryApiFetchParamCreator.createTitlesBigquerySharedQuery(
        titleUuid,
        env,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param sharedQueryId 
     * @param {*} [options] Override http request option.
     */
    async destroyTitlesBigquerySharedQuery(
      titleUuid: string,
      env: string,
      sharedQueryId: number,
      options: any = {},
      ): Promise<SharedQueryApi.DestroyTitlesBigquerySharedQueryResponse> {
      const fetchArgs = SharedQueryApiFetchParamCreator.destroyTitlesBigquerySharedQuery(
        titleUuid,
        env,
        sharedQueryId,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param {*} [options] Override http request option.
     */
    async indexTitlesBigquerySharedQuery(
      titleUuid: string,
      env: string,
      options: any = {},
      ): Promise<SharedQueryApi.IndexTitlesBigquerySharedQueryResponse> {
      const fetchArgs = SharedQueryApiFetchParamCreator.indexTitlesBigquerySharedQuery(
        titleUuid,
        env,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * 
     * @param titleUuid 
     * @param env 
     * @param sharedQueryId 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async updateTitlesBigquerySharedQuery(
      titleUuid: string,
      env: string,
      sharedQueryId: number,
      body: {
        name: string;
        query: string;
      },
      options: any = {},
      ): Promise<SharedQueryApi.UpdateTitlesBigquerySharedQueryResponse> {
      const fetchArgs = SharedQueryApiFetchParamCreator.updateTitlesBigquerySharedQuery(
        titleUuid,
        env,
        sharedQueryId,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
  },
  /**
   * StatusesApi
   */
  StatusesApi: {
    /**
     * Get Status
     * @summary Get Status
     * @param {*} [options] Override http request option.
     */
    async getStatus(
      options: any = {},
      ): Promise<StatusesApi.GetStatusResponse> {
      const fetchArgs = StatusesApiFetchParamCreator.getStatus(
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: await response.text() };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
  },
  /**
   * UserTitleRolesApi
   */
  UserTitleRolesApi: {
    /**
     * UserTitleRoleを新規に作成します。
     * @summary UserTitleRoleの作成
     * @param titleUuid 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async createUserTitleRole(
      titleUuid: string,
      body: {
        /**
         * User
         */
        user: {
          /**
           * Role
           */
          role: string;
          /**
           * Ndids
           */
          ndids: string;
          /**
           * Uids
           */
          uids: Array<string>;
        };
      },
      options: any = {},
      ): Promise<UserTitleRolesApi.CreateUserTitleRoleResponse> {
      const fetchArgs = UserTitleRolesApiFetchParamCreator.createUserTitleRole(
        titleUuid,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 400:
          return { code: 400, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 500:
          return { code: 500, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 503:
          return { code: 503, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * UserTitleRoleを削除します。
     * @summary UserTitleRoleの削除
     * @param titleUuid 
     * @param params.user.ids User Ids
     * @param {*} [options] Override http request option.
     */
    async destroyUserTitleRole(
      titleUuid: string,
      params: {
        user: {
          /**
           * User Ids
           */
          ids: Array<number>;
        }      },
      options: any = {},
      ): Promise<UserTitleRolesApi.DestroyUserTitleRoleResponse> {
      const fetchArgs = UserTitleRolesApiFetchParamCreator.destroyUserTitleRole(
        titleUuid,
        params,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 400:
          return { code: 400, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 500:
          return { code: 500, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 503:
          return { code: 503, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * Registered UserTitleRole
     * @summary Registered UserTitleRole
     * @param titleUuid 
     * @param {*} [options] Override http request option.
     */
    async registeredUserTitleRole(
      titleUuid: string,
      options: any = {},
      ): Promise<UserTitleRolesApi.RegisteredUserTitleRoleResponse> {
      const fetchArgs = UserTitleRolesApiFetchParamCreator.registeredUserTitleRole(
        titleUuid,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 400:
          return { code: 400, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 503:
          return { code: 503, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * Unregistered UserTitleRole
     * @summary Unregistered UserTitleRole
     * @param titleUuid 
     * @param params.loginidFilter 
     * @param {*} [options] Override http request option.
     */
    async unregisteredUserTitleRole(
      titleUuid: string,
      params: {
        loginidFilter: string;      },
      options: any = {},
      ): Promise<UserTitleRolesApi.UnregisteredUserTitleRoleResponse> {
      const fetchArgs = UserTitleRolesApiFetchParamCreator.unregisteredUserTitleRole(
        titleUuid,
        params,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 400:
          return { code: 400, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 500:
          return { code: 500, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 503:
          return { code: 503, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
    /**
     * UserTitleRoleを更新します。
     * @summary UserTitleRoleの更新
     * @param titleUuid 
     * @param body 
     * @param {*} [options] Override http request option.
     */
    async updateUserTitleRole(
      titleUuid: string,
      body: {
        /**
         * User
         */
        user: {
          /**
           * Role
           */
          role: string;
          /**
           * Ids
           */
          ids: Array<number>;
        };
      },
      options: any = {},
      ): Promise<UserTitleRolesApi.UpdateUserTitleRoleResponse> {
      const fetchArgs = UserTitleRolesApiFetchParamCreator.updateUserTitleRole(
        titleUuid,
        body,
        options,
      );
      const response = await fetch(basePath + fetchArgs.url, fetchArgs.options);
      switch (response.status) {
        case 200:
          return { code: 200, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 400:
          return { code: 400, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 401:
          return { code: 401, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 403:
          return { code: 403, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 500:
          return { code: 500, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        case 503:
          return { code: 503, ok: response.ok, body: transformKeysToCamelCase(await response.json()) };
        default:
          return { code: null, ok: false, body: new UnexpectedResponseError(response) };
      }
    },
  },
});

const defaultClient = ClientFactory();

export namespace BigqueryApi {
  export type DdlTitlesBigqueryTableResponse = { code: 200, ok: boolean, body: string } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type DestroyTitlesBigqueryTableResponse = { code: 200, ok: boolean, body: DestroyTitlesBigqueryTableResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: 412, ok: boolean, body: DestroyTitlesBigqueryTableResponse412 } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type IndexTitlesBigqueryTableResponse = { code: 200, ok: boolean, body: Array<BigqueryTable> } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };

  export const ddlTitlesBigqueryTable = defaultClient.BigqueryApi.ddlTitlesBigqueryTable;
  export const destroyTitlesBigqueryTable = defaultClient.BigqueryApi.destroyTitlesBigqueryTable;
  export const indexTitlesBigqueryTable = defaultClient.BigqueryApi.indexTitlesBigqueryTable;
}
export namespace EventMastersApi {
  export type CopyFromS3EventMastersBigqueryResponse = { code: 200, ok: boolean, body: CopyFromS3EventMastersBigqueryResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: 503, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type DdlEventMastersBigqueryResponse = { code: 200, ok: boolean, body: DdlEventMastersBigqueryResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: 503, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type DeleteEventMastersS3Response = { code: 200, ok: boolean, body: DeleteEventMastersS3Response200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type DeployEventMasterEventMastersBigqueryResponse = { code: 200, ok: boolean, body: DeployEventMasterEventMastersBigqueryResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: 412, ok: boolean, body: DeployEventMasterEventMastersBigqueryResponse412 } | { code: 503, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type JsonpathEventMastersBigqueryResponse = { code: 200, ok: boolean, body: JsonpathEventMastersBigqueryResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: 503, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type LastCopyStatusEventMastersJobResponse = { code: 200, ok: boolean, body: LastCopyStatusEventMastersJobResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type LastDeployStatusEventMastersJobResponse = { code: 200, ok: boolean, body: LastDeployStatusEventMastersJobResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type S3StatsEventMastersBigqueryResponse = { code: 200, ok: boolean, body: Array<S3Stats> } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: 503, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type ShowEventMasterResponse = { code: 200, ok: boolean, body: EventMaster } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type ShowEventMastersBigqueryLoadStatusResponse = { code: 200, ok: boolean, body: BigqueryLoadStatus } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type ShowEventMastersSuggestionResponse = { code: 200, ok: boolean, body: string } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type TableStatusEventMastersBigqueryResponse = { code: 200, ok: boolean, body: BigqueryTableStatus } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: 503, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type UpdateEventMasterResponse = { code: 200, ok: boolean, body: UpdateEventMasterResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type UpdateVersionNoteEventMasterResponse = { code: 200, ok: boolean, body: UpdateVersionNoteEventMasterResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };

  export const copyFromS3EventMastersBigquery = defaultClient.EventMastersApi.copyFromS3EventMastersBigquery;
  export const ddlEventMastersBigquery = defaultClient.EventMastersApi.ddlEventMastersBigquery;
  export const deleteEventMastersS3 = defaultClient.EventMastersApi.deleteEventMastersS3;
  export const deployEventMasterEventMastersBigquery = defaultClient.EventMastersApi.deployEventMasterEventMastersBigquery;
  export const jsonpathEventMastersBigquery = defaultClient.EventMastersApi.jsonpathEventMastersBigquery;
  export const lastCopyStatusEventMastersJob = defaultClient.EventMastersApi.lastCopyStatusEventMastersJob;
  export const lastDeployStatusEventMastersJob = defaultClient.EventMastersApi.lastDeployStatusEventMastersJob;
  export const s3StatsEventMastersBigquery = defaultClient.EventMastersApi.s3StatsEventMastersBigquery;
  export const showEventMaster = defaultClient.EventMastersApi.showEventMaster;
  export const showEventMastersBigqueryLoadStatus = defaultClient.EventMastersApi.showEventMastersBigqueryLoadStatus;
  export const showEventMastersSuggestion = defaultClient.EventMastersApi.showEventMastersSuggestion;
  export const tableStatusEventMastersBigquery = defaultClient.EventMastersApi.tableStatusEventMastersBigquery;
  export const updateEventMaster = defaultClient.EventMastersApi.updateEventMaster;
  export const updateVersionNoteEventMaster = defaultClient.EventMastersApi.updateVersionNoteEventMaster;
}
export namespace QueryApi {
  export type ChatHistoriesTitlesBigqueryQueryResponse = { code: 200, ok: boolean, body: Array<ChatHistoriesTitlesBigqueryQueryResponse200> } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type ChatHistoryTitlesBigqueryQueryResponse = { code: 200, ok: boolean, body: Array<ChatHistoryTitlesBigqueryQueryResponse200> } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type ChatTitlesBigqueryQueryResponse = { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type CompleteTitlesBigqueryQueryResponse = { code: 200, ok: boolean, body: CompleteTitlesBigqueryQueryResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type CreateTitlesBigqueryQueryResponse = { code: 200, ok: boolean, body: CreateTitlesBigqueryQueryResponse200 } | { code: 400, ok: boolean, body: CreateTitlesBigqueryQueryResponse400 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type DryrunTitlesBigqueryQueryResponse = { code: 200, ok: boolean, body: BigqueryDryrunResult } | { code: 400, ok: boolean, body: DryrunTitlesBigqueryQueryResponse400 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type EditTitlesBigqueryQueryResponse = { code: 200, ok: boolean, body: EditTitlesBigqueryQueryResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type ExportTitlesBigqueryQueryResponse = { code: 200, ok: boolean, body: ExportTitlesBigqueryQueryResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type FixTitlesBigqueryQueryResponse = { code: 200, ok: boolean, body: FixTitlesBigqueryQueryResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type IndexTitlesBigqueryQueryResponse = { code: 200, ok: boolean, body: Array<BigqueryQuery> } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type NesTitlesBigqueryQueryResponse = { code: 200, ok: boolean, body: NesTitlesBigqueryQueryResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type ShowTitlesBigqueryChatPreferenceResponse = { code: 200, ok: boolean, body: ShowTitlesBigqueryChatPreferenceResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type ShowTitlesBigqueryQueryResponse = { code: 200, ok: boolean, body: BigqueryQueryResult } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type StopTitlesBigqueryQueryResponse = { code: 200, ok: boolean, body: StopTitlesBigqueryQueryResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type UpdateTitlesBigqueryChatPreferenceResponse = { code: 200, ok: boolean, body: UpdateTitlesBigqueryChatPreferenceResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };

  export const chatHistoriesTitlesBigqueryQuery = defaultClient.QueryApi.chatHistoriesTitlesBigqueryQuery;
  export const chatHistoryTitlesBigqueryQuery = defaultClient.QueryApi.chatHistoryTitlesBigqueryQuery;
  export const chatTitlesBigqueryQuery = defaultClient.QueryApi.chatTitlesBigqueryQuery;
  export const completeTitlesBigqueryQuery = defaultClient.QueryApi.completeTitlesBigqueryQuery;
  export const createTitlesBigqueryQuery = defaultClient.QueryApi.createTitlesBigqueryQuery;
  export const dryrunTitlesBigqueryQuery = defaultClient.QueryApi.dryrunTitlesBigqueryQuery;
  export const editTitlesBigqueryQuery = defaultClient.QueryApi.editTitlesBigqueryQuery;
  export const exportTitlesBigqueryQuery = defaultClient.QueryApi.exportTitlesBigqueryQuery;
  export const fixTitlesBigqueryQuery = defaultClient.QueryApi.fixTitlesBigqueryQuery;
  export const indexTitlesBigqueryQuery = defaultClient.QueryApi.indexTitlesBigqueryQuery;
  export const nesTitlesBigqueryQuery = defaultClient.QueryApi.nesTitlesBigqueryQuery;
  export const showTitlesBigqueryChatPreference = defaultClient.QueryApi.showTitlesBigqueryChatPreference;
  export const showTitlesBigqueryQuery = defaultClient.QueryApi.showTitlesBigqueryQuery;
  export const stopTitlesBigqueryQuery = defaultClient.QueryApi.stopTitlesBigqueryQuery;
  export const updateTitlesBigqueryChatPreference = defaultClient.QueryApi.updateTitlesBigqueryChatPreference;
}
export namespace RawPostsApi {
  export type IndexTitlesRawPostResponse = { code: 200, ok: boolean, body: IndexTitlesRawPostResponse200 } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type ShowRawPostResponse = { code: 200, ok: boolean, body: RawPost } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };

  export const indexTitlesRawPost = defaultClient.RawPostsApi.indexTitlesRawPost;
  export const showRawPost = defaultClient.RawPostsApi.showRawPost;
}
export namespace SavedQueryApi {
  export type CreateTitlesBigquerySavedQueryResponse = { code: 200, ok: boolean, body: BigquerySavedQuery } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type DestroyTitlesBigquerySavedQueryResponse = { code: 200, ok: boolean, body: DestroyTitlesBigquerySavedQueryResponse200 } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type IndexTitlesBigquerySavedQueryResponse = { code: 200, ok: boolean, body: Array<BigquerySavedQuery> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type UpdateTitlesBigquerySavedQueryResponse = { code: 200, ok: boolean, body: BigquerySavedQuery } | { code: null, ok: boolean, body: UnexpectedResponseError };

  export const createTitlesBigquerySavedQuery = defaultClient.SavedQueryApi.createTitlesBigquerySavedQuery;
  export const destroyTitlesBigquerySavedQuery = defaultClient.SavedQueryApi.destroyTitlesBigquerySavedQuery;
  export const indexTitlesBigquerySavedQuery = defaultClient.SavedQueryApi.indexTitlesBigquerySavedQuery;
  export const updateTitlesBigquerySavedQuery = defaultClient.SavedQueryApi.updateTitlesBigquerySavedQuery;
}
export namespace SharedQueryApi {
  export type CreateTitlesBigquerySharedQueryResponse = { code: 200, ok: boolean, body: BigquerySharedQuery } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type DestroyTitlesBigquerySharedQueryResponse = { code: 200, ok: boolean, body: DestroyTitlesBigquerySharedQueryResponse200 } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type IndexTitlesBigquerySharedQueryResponse = { code: 200, ok: boolean, body: Array<BigquerySharedQuery> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type UpdateTitlesBigquerySharedQueryResponse = { code: 200, ok: boolean, body: BigquerySharedQuery } | { code: null, ok: boolean, body: UnexpectedResponseError };

  export const createTitlesBigquerySharedQuery = defaultClient.SharedQueryApi.createTitlesBigquerySharedQuery;
  export const destroyTitlesBigquerySharedQuery = defaultClient.SharedQueryApi.destroyTitlesBigquerySharedQuery;
  export const indexTitlesBigquerySharedQuery = defaultClient.SharedQueryApi.indexTitlesBigquerySharedQuery;
  export const updateTitlesBigquerySharedQuery = defaultClient.SharedQueryApi.updateTitlesBigquerySharedQuery;
}
export namespace StatusesApi {
  export type GetStatusResponse = { code: 200, ok: boolean, body: string } | { code: null, ok: boolean, body: UnexpectedResponseError };

  export const getStatus = defaultClient.StatusesApi.getStatus;
}
export namespace UserTitleRolesApi {
  export type CreateUserTitleRoleResponse = { code: 200, ok: boolean, body: CreateUserTitleRoleResponse200 } | { code: 400, ok: boolean, body: Array<ApiError> } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: 500, ok: boolean, body: CreateUserTitleRoleResponse500 } | { code: 503, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type DestroyUserTitleRoleResponse = { code: 200, ok: boolean, body: DestroyUserTitleRoleResponse200 } | { code: 400, ok: boolean, body: Array<ApiError> } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: 500, ok: boolean, body: DestroyUserTitleRoleResponse500 } | { code: 503, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type RegisteredUserTitleRoleResponse = { code: 200, ok: boolean, body: Array<UserTitleRole> } | { code: 400, ok: boolean, body: Array<ApiError> } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: 503, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type UnregisteredUserTitleRoleResponse = { code: 200, ok: boolean, body: Array<NotExistUserTitleRole> } | { code: 400, ok: boolean, body: Array<ApiError> } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: 500, ok: boolean, body: Array<ApiError> } | { code: 503, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };
  export type UpdateUserTitleRoleResponse = { code: 200, ok: boolean, body: UpdateUserTitleRoleResponse200 } | { code: 400, ok: boolean, body: Array<ApiError> } | { code: 401, ok: boolean, body: Array<ApiError> } | { code: 403, ok: boolean, body: Array<ApiError> } | { code: 500, ok: boolean, body: UpdateUserTitleRoleResponse500 } | { code: 503, ok: boolean, body: Array<ApiError> } | { code: null, ok: boolean, body: UnexpectedResponseError };

  export const createUserTitleRole = defaultClient.UserTitleRolesApi.createUserTitleRole;
  export const destroyUserTitleRole = defaultClient.UserTitleRolesApi.destroyUserTitleRole;
  export const registeredUserTitleRole = defaultClient.UserTitleRolesApi.registeredUserTitleRole;
  export const unregisteredUserTitleRole = defaultClient.UserTitleRolesApi.unregisteredUserTitleRole;
  export const updateUserTitleRole = defaultClient.UserTitleRolesApi.updateUserTitleRole;
}
